import type {
  PaymentIntentCreateResponseType,
  RemainingBalancePaymentIntentCreateRequestType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useRemainingBalancePaymentIntentCreate = () => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: (data: RemainingBalancePaymentIntentCreateRequestType) =>
      apiV2Request({
        user,
        business,
        method: "post",
        path: "payment-intent/remaining-balance",
        data,
      }).then(
        (response) =>
          apiV2AssertResponse<PaymentIntentCreateResponseType>(response).data,
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [user?.uid, business?.id, ServerStateKeys.Payments],
      });
      queryClient.invalidateQueries({
        queryKey: [user?.uid, business?.id, ServerStateKeys.PaymentIntents],
      });
    },
  });
};
